import { render, staticRenderFns } from "./ticketManagePush.vue?vue&type=template&id=d2622744"
import script from "./ticketManagePush.vue?vue&type=script&lang=js"
export * from "./ticketManagePush.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports